import styled from "styled-components";
import { HXButton } from "./HXButton";
import { HXPage } from "./HXDesktopPage";
export const StudiesViewParent = styled(HXPage) ``;
export const CreateStudyButton = styled(HXButton) `
    margin-left: auto;
`;
